import CryptoJS from "crypto-js";
import {ActionType} from "../enums/common";
import {GPSTrackerStatus, IStatusType, StatusType} from "../enums/live";
const sKey: string = process.env.NEXT_PUBLIC_NEO_SECRET || "";

export const isNumber = (value: any): value is number => {
  return typeof value === "number";
};

export const isString = (value: any): value is string => {
  return typeof value === "string";
};

export const encrypt = async (data?: string, key?: string) => {
  if (data && key) {
    const encrypted = await CryptoJS.AES.encrypt(data, key);
    return encrypted.toString();
  }
  return null;
};

export const decrypt = async (ciphertext?: string, key?: string) => {
  if (ciphertext && key) {
    const decrypted = await CryptoJS.AES.decrypt(ciphertext, key);
    return decrypted.toString(CryptoJS.enc.Utf8);
  }
  return null;
};

export const encryptUrl = async (data?: string, key?: string) => {
  if (data && key) {
    const encrypted = await CryptoJS.AES.encrypt(data, key).toString();
    const ciphertext = CryptoJS.enc.Base64.parse(encrypted);
    return CryptoJS.enc.Hex.stringify(ciphertext);
  }
  return null;
};

export const decryptUrl = async (ciphertext?: string, key?: string) => {
  if (ciphertext && key) {
    const decrypted = CryptoJS.enc.Hex.parse(ciphertext).toString(
      CryptoJS.enc.Base64
    );
    const deciphertext = await CryptoJS.AES.decrypt(decrypted, key);
    return deciphertext.toString(CryptoJS.enc.Utf8);
  }
  return null;
};

export const convertMTOKM = (m: any) => {
  return m && m != 0 ? (m / 1000).toFixed(2) + " kms" : "0 km";
};

export const toKilometers = (km: any): number => {
  // return km && km != 0 ? (km * 1000).toFixed(2) : 0;
  return Number.isFinite(km) ? parseFloat((km / 1000).toFixed(2)) : 0;
};

export const toDay = (timeStamp: any): string => {
  const date = new Date(timeStamp);
  const day = date.getDate();
  const hours = date.getHours();
  const min = date.getMinutes();

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ];
  let hoursStr = "";
  if (hours > 0) {
    hoursStr += `${hours} : ${min}`;
  }
  const monthSTr = monthNames[date.getMonth()];
  return hoursStr ? hoursStr : `${monthSTr} ${day}`;
};
export const fetchFilterStatus = (s: IStatusType) => {
  switch (s) {
    case IStatusType.COMPLETEDTRIP:
      return StatusType.COMPLETED;
    case IStatusType.ONTRIP:
      return StatusType.INPROGRESS;
    case IStatusType.OFFTRIP:
      return StatusType.NOTINTRIP;
  }
};

export const fetchCurrentStatus = (g: GPSTrackerStatus, details: Details) => {
  switch (g) {
    case GPSTrackerStatus.MOVING:
      return "Moving";
    case GPSTrackerStatus.OFFLINE:
      return "Offline";
    case GPSTrackerStatus.DEAD:
      return "Unknown";
    case GPSTrackerStatus.STATIONARY:
      return details?.location?.ti ? "Stationary" : "Stationary";
  }
};

export const fetchTripStatus = (
  g: GPSTrackerStatus,
  hasRoute: boolean,
  details: Details
) => {
  switch (g) {
    case GPSTrackerStatus.MOVING:
      return hasRoute
        ? `Planned trip on route ${details?.onTripData?.routeName}`
        : `Unplanned trip`;
    case GPSTrackerStatus.OFFLINE:
      return `Offline since ${details?.location?.ti ? calcTime(details?.location?.ti) : "unknown"}`;
    case GPSTrackerStatus.DEAD:
      return "Have not received any data from this tracker";
    case GPSTrackerStatus.STATIONARY:
      return `Stationary since ${details?.location?.ti ? calcTime(details?.location?.ti) : "unknown"}`;
  }
};

export const calcTime = (time: number, type?: string) => {
  const currentDate = new Date();
  const providedDate = new Date(time);
  const timeDifference = (new Date().getTime() - time) / 1000;
  const units = ["second", "minute", "hour", "day"];
  const values = [60, 60, 24];

  const unitIndex = Math.max(
    0,
    ...values.map((value, index) => (timeDifference >= value ? index + 1 : 0))
  );
  const roundedDifference = Math.floor(
    timeDifference /
      values.slice(0, unitIndex).reduce((acc, val) => acc * val, 1)
  );
  const unit = units[unitIndex] + (roundedDifference !== 1 ? "s" : "");
  if (type === "short") {
    if (
      unit === "minutes" ||
      unit === "minute" ||
      unit === "second" ||
      unit === "seconds"
    ) {
      const secondsDifference = Math.floor(timeDifference % 60);
      return secondsDifference > 0
        ? `${roundedDifference}m ${secondsDifference}s`
        : `${roundedDifference}m`;
    }
    return "";
  } else {
    if (unit === "day" || unit === "days") {
      const yesterday = new Date(currentDate);
      yesterday.setDate(currentDate.getDate() - 1);
      if (yesterday.toDateString() === providedDate.toDateString()) {
        return `yesterday ${formatTime(providedDate)}`;
      }
    }
    return `${formatDateTime(providedDate)}`;
  }
};

export const formatTime = (dt: any) => {
  // its format like 05:10:35
  return new Date(dt).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
};

export const formatDateTime = (dt: any) => {
  return new Date(dt)
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      //year: "numeric",
      // Short month name (e.g., "Nov")
      hour: "2-digit",
      minute: "2-digit",
      //second: "2-digit",
      hour12: true // 12-hour format
    })
    .replace(/\//g, "-");
};

export const formatDateCommon = (dt: any) => {
  return new Date(dt)
    .toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric"
      // Short month name (e.g., "Nov")
      // hour: "2-digit",
      // minute: "2-digit",
      //second: "2-digit",
      // hour12: true // 12-hour format
    })
    .replace(/\//g, "-");
};
export const convertTOPeriod = (t: any) => {
  return t && t != 0
    ? new Date(t).setHours(0, 0, 0, 0) === new Date().setHours(0, 0, 0, 0)
      ? formatDateTime(t)
      : `Since ${formatDateTime(t)}`
    : "NA";
};

export const onGetTableResponse = () => {
  const result: TableResponse<any> = {};
  ((result.columns = []),
    (result.rows = []),
    (result.meta = {} as Meta),
    (result.errors = "No result Found"));
  return result;
};

export const mapFields = <T>(data: T[], config: TNeoField[]): TNeoField[] => {
  return data
    .map(item => {
      return config.map(field => {
        return {
          label: field.label,
          value:
            field.key &&
            (item as any)[field?.key] != null &&
            (item as any)[field?.key] !== ""
              ? field.type === "date"
                ? (item as any)[field?.key] == 0
                  ? "N/A"
                  : formatDateCommon((item as any)[field?.key])
                : (item as any)[field?.key]?.toString()
              : "N/A",
          key: field.key,
          type: field.type,
          isVisible: field?.isVisible
        };
      });
    })
    .flat();
};

export const formatDate = (date: Date): string => {
  // Example format: "YYYY-MM-DD"
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
  const day = date.getDate().toString().padStart(2, "0");

  // Adjust the format string according to your needs
  return `${year}-${month}-${day}`;
};

export const navigateToEditPage = async (
  entity: string,
  entityId: string,
  entityPath: string
) => {
  const encryptedId = await encryptUrl(entityId, sKey);
  const route = `/${entity}/${encryptedId}/edit/${entityPath}`;

  return route;
};

export const ConvertDateTimeToDate = (datetime: any): string => {
  // Example format: "13-11-2024, 05:10:35 pm"
  // Example convertformat: "DD-MM-YYYY"
  const [datePart, timePart] = datetime.split(", ");
  const [requestday, requestmonth, requestyear] = datePart.split("-");
  const date = new Date(`${requestyear}-${requestmonth}-${requestday}`);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
  const day = date.getDate().toString().padStart(2, "0");

  // Adjust the format string according to your needs
  return `${day}-${month}-${year}`;
};

export const ConvertDateTimeToTime = (datetime: any): string => {
  // Example format: "13-11-2024, 05:10:35 pm"
  // Example convertformat: "DD-MM-YYYY"
  const [datePart, timePart] = datetime.split(", ");
  const [requestday, requestmonth, requestyear] = datePart.split("-");
  const date = new Date(`${requestyear}-${requestmonth}-${requestday}`);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based
  const day = date.getDate().toString().padStart(2, "0");

  // Adjust the format string according to your needs
  return `${day}-${month}-${year}`;
};

export const convertKMTOM = (km: any) => {
  const m = km * 1000;
  return m;
};

export const msToReadableTime = (ms: number): string => {
  const hours = Math.floor(ms / (1000 * 60 * 60));
  const minutes = Math.floor((ms % (1000 * 60 * 60)) / (1000 * 60));
  let opReadableTime = "";
  if (hours > 0) {
    opReadableTime += `${hours} hours `;
  }
  opReadableTime += `${minutes} min`;
  return opReadableTime;
};

export const constractMapUrl = (lat: any, lng: any): string => {
  return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
};

export const constractMapUrlWithDirections = (latLngs: string[]): string => {
  const directionUrl =
    "https://www.google.com/maps/dir/" +
    latLngs.map((latLng: string) => latLng.trim()).join("/");
  return directionUrl;
};

export const constractSwipesStr = (swipedatas: any): string => {
  let time = "";
  let vehicleName = "";
  const triptype = swipedatas?.type;

  if (swipedatas?.time) {
    const swipetime = calcTime(swipedatas?.time);
    const [datePart, timePart] = swipetime.split(", ");
    time = timePart;
  }
  if (swipedatas?.vehicleName) {
    vehicleName = swipedatas?.vehicleName;
  }

  let swipes = "";
  if (swipedatas?.vehicleName && time) {
    swipes = `${vehicleName} (${time})`;
  } else if (time) {
    swipes = time;
  }

  // if (triptype == 1) {
  //   out_drop_time = swipes;
  // } else {
  //   in_pick_time = swipes;
  // }
  return swipes;
};

export const getTableConfigWithAccess = (
  roleAccess: RoleAccess[] | null | undefined,
  baseConfig: any,
  moduleCode: string
) => {
  // i have to deep clone the object to avoid mutating the original config
  // because object is reference type
  // https://stackoverflow.com/questions/122102/what-is-the-most-efficient-way-to-deep-clone-an-object-in-javascript
  const data = JSON.parse(JSON.stringify(baseConfig));

  if (roleAccess && roleAccess.length > 0) {
    const menuAccess = getModuleAccess(roleAccess, moduleCode);

    data.table.meta.hasAdd = !!menuAccess?.write;
    data.table.meta.hasCreate = !!menuAccess?.write;

    if (data.table.actions) {
      data.table.actions = data.table.actions.map((action: any) => {
        if (action.key === "edit") {
          return {
            ...action,
            isVisible: menuAccess?.update ?? false
          };
        } else if (action.key === "delete") {
          return {
            ...action,
            isVisible: false
          };
        }
        return action;
      });
    }
  } else {
    // no access, set to default if no access
    const defaultTableData = JSON.parse(JSON.stringify(baseConfig));
    data.table.meta = {...defaultTableData.table.meta};
    data.table.actions = [...(defaultTableData.table.actions ?? [])];
  }

  return data;
};

export const getModuleAccess = (
  roleAccess: RoleAccess[] | null | undefined,
  moduleCode: string
) => {
  if (!roleAccess?.length) {
    return null;
  }

  return roleAccess.find(access => access.moduleCode === moduleCode) ?? null;
};

export const canAccessCrudAction = (
  roleAccess: RoleAccess[] | null | undefined,
  moduleCode: string,
  action: string
) => {
  if (!roleAccess?.length) {
    return true;
  }

  const moduleAccess = getModuleAccess(roleAccess, moduleCode);

  if (action === ActionType.CREATE) {
    return !!moduleAccess?.write;
  }

  if (action === ActionType.EDIT) {
    return !!moduleAccess?.update;
  }

  return true;
};

export const canReadModule = (
  roleAccess: RoleAccess[] | null | undefined,
  moduleCode: string
) => {
  if (!roleAccess?.length) {
    return true;
  }

  const moduleAccess = getModuleAccess(roleAccess, moduleCode);
  return moduleAccess?.read === true;
};

export const millisecondsToMinutes = (ms: number): number => {
  return Math.floor(ms / 60000);
};

export const formatTimeWithoutSecods = (dt: any) => {
  // its format like 05:10
  return new Date(dt).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const formatTimeFromMs = (ms: number): string => {
  //   Sample usage:
  //   millisecondsToMinutes(4080000); // "1 hr 8 min"
  // millisecondsToMinutes(7200000); // "2 hr"
  // millisecondsToMinutes(300000);  // "5 min"
  const totalMinutes = Math.floor(ms / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0 && minutes > 0) {
    return `${hours} hr ${minutes} min`;
  } else if (hours > 0) {
    return `${hours} hr`;
  } else {
    return `${minutes} min`;
  }
};

export const fmtTime = (ms?: number) => {
  if (!ms || Number.isNaN(ms)) return "-";
  return new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true
  }).format(new Date(ms));
};

export const onDownload = async (fileUrl: any, fileName = "") => {
  try {
    // fetch the file as blob
    const res = await fetch(fileUrl, {mode: "cors"});
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    if (!fileName) {
      const urlParts = fileUrl.split("/");
      fileName = urlParts[urlParts.length - 1];
      //    const now = new Date();
      // const timestamp = now
      //   .toISOString()
      //   .replace("T", "_")
      //   .replace(/:/g, "-")
      //   .split(".")[0];
    }

    const blob = await res.blob();

    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    // cleanup
    a.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    //console.log(err);
  }
};

export const downloadCSV = (data: any[], fileName = "export.csv") => {
  if (!data || data.length === 0) return;

  const keys = Object.keys(data[0]);
  const csvRows = [];

  // Header
  csvRows.push(keys.join(","));

  // Values
  for (const row of data) {
    const values = keys.map(key => {
      const value = row[key] ?? "";
      return `"${String(value).replace(/"/g, '""')}"`; // escape quotes
    });
    csvRows.push(values.join(","));
  }

  const csvString = csvRows.join("\n");
  const blob = new Blob([csvString], {type: "text/csv;charset=utf-8;"});
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
};
